export default "__VITE_ASSET__e30ce868__"